export enum RoleType {
	SuperAdmin = '9a783c01-1234-4567-8901-abcdef123456',

	UniversityAdmin = '9a783c02-1234-4567-8901-abcdef123456',
	Rector = '9a783c03-1234-4567-8901-abcdef123456',
	FacultyDean = '9a783c04-1234-4567-8901-abcdef123456',
	GeneralDirector = '9a783c05-1234-4567-8901-abcdef123456',
	UniversityGeneralSecretary = '9a783c06-1234-4567-8901-abcdef123456',
	UniversityEducationalSecretary = '9a783c07-1234-4567-8901-abcdef123456',
	UniversityCareerSecretary = '9a783c08-1234-4567-8901-abcdef123456',
	AgreementsOfficeHead = '9a783c09-1234-4567-8901-abcdef123456',
	UniversityAgreementsOffice = '9a783c10-1234-4567-8901-abcdef123456',
	QualityMonitoringHead = '9a783c11-1234-4567-8901-abcdef123456',
	UniversityQualityMonitoring = '9a783c12-1234-4567-8901-abcdef123456',
	UniversityRadiationExpert = '9a783c13-1234-4567-8901-abcdef123456',
	UniversityPreventionHead = '9a783c14-1234-4567-8901-abcdef123456',

	// Internship module profiles
	Student = '9a783c30-1234-4567-8901-abcdef123456',
	Trainee = '9a783c23-1234-4567-8901-abcdef123456',
	InternshipCoordinatorProfessor = '9a783c31-1234-4567-8901-abcdef123456',
	InternshipSecretary = '9a783c32-1234-4567-8901-abcdef123456',
	InternshipTutor = '9a783c33-1234-4567-8901-abcdef123456',

	SchoolAdmin = '9a783c15-1234-4567-8901-abcdef123456',
	SchoolAgreementsOffice = '9a783c16-1234-4567-8901-abcdef123456',
	SchoolQualityMonitoring = '9a783c17-1234-4567-8901-abcdef123456',
	SchoolSecretary = '9a783c18-1234-4567-8901-abcdef123456',
	SchoolDirector = '9a783c19-1234-4567-8901-abcdef123456',
	ViceDirector = '9a783c20-1234-4567-8901-abcdef123456',
	CoordinatorProfessor = '9a783c21-1234-4567-8901-abcdef123456',
	Tutor = '9a783c22-1234-4567-8901-abcdef123456',
	
	Professor = '9a783c24-1234-4567-8901-abcdef123456',

	OperationalTutor = '9a783c25-1234-4567-8901-abcdef123456',
	OperationalUnitDirector = '9a783c26-1234-4567-8901-abcdef123456',
	MedicalDirector = '9a783c27-1234-4567-8901-abcdef123456',
	HealthcareRadiationExpert = '9a783c28-1234-4567-8901-abcdef123456',
	HealthcarePreventionHead = '9a783c29-1234-4567-8901-abcdef123456',
}

export enum OperationalUnitRoleType {
	OperationalTutor = '9a783c25-1234-4567-8901-abcdef123456',
	OperationalUnitDirector = '9a783c26-1234-4567-8901-abcdef123456',
	MedicalDirector = '9a783c27-1234-4567-8901-abcdef123456',
	HealthcareRadiationExpert = '9a783c28-1234-4567-8901-abcdef123456',
	HealthcarePreventionHead = '9a783c29-1234-4567-8901-abcdef123456',
}

export enum SchoolUniversityRoleType {
	SchoolAdmin = '9a783c15-1234-4567-8901-abcdef123456',
	SchoolAgreementsOffice = '9a783c16-1234-4567-8901-abcdef123456',
	SchoolQualityMonitoring = '9a783c17-1234-4567-8901-abcdef123456',
	SchoolSecretary = '9a783c18-1234-4567-8901-abcdef123456',
	SchoolDirector = '9a783c19-1234-4567-8901-abcdef123456',
	ViceDirector = '9a783c20-1234-4567-8901-abcdef123456',
	CoordinatorProfessor = '9a783c21-1234-4567-8901-abcdef123456',
	Tutor = '9a783c22-1234-4567-8901-abcdef123456',
	Trainee = '9a783c23-1234-4567-8901-abcdef123456',
	Professor = '9a783c24-1234-4567-8901-abcdef123456',
}

export enum InternshipRoleType {
	Student = '9a783c30-1234-4567-8901-abcdef123456',
	Trainee = '9a783c23-1234-4567-8901-abcdef123456',
	InternshipCoordinatorProfessor = '9a783c31-1234-4567-8901-abcdef123456',
	InternshipSecretary = '9a783c32-1234-4567-8901-abcdef123456',
	InternshipTutor = '9a783c33-1234-4567-8901-abcdef123456',
}
